<template>
    <div
		class="content-factors"
		:class="{ 'rotated' : rotatedCard }"
		:style="`color:${$appColors.info}`"
	>
		<v-layout
			class="detail-content"
			wrap
			align-center
			justify-center
			mb-3
			v-if="showStep"
		>
			<v-flex xs12 text-xs-center v-if="showNumber">
				<v-avatar :style="`background-color:${$appColors.primary}`">
					<span class="white--text title pl-0">{{ number }}</span>
				</v-avatar>
			</v-flex>
			<v-flex xs12>
				<p class="text-blue" :style="`color:${$appColors.primary}`">{{ title }}</p>
			</v-flex>
		</v-layout>
		<v-layout wrap class="card-layout">
			<v-flex xs12>
				<div class="card" :style="`height: calc(100vh - ${width || (showStep ? '320px' : '226px')})`">
					<slot></slot>
				</div>
			</v-flex>
		</v-layout>
		<v-layout justify-space-between align-center px-3 class="buttons-factors">
			<slot name="footer"></slot>
			<v-flex text-xs-center v-if="!!cancelActionText">
				<v-btn
					type="button"
					small
					class="btn-action btn-detail"
					color="info"
					@click="$emit('cancel-action')"
				>
					{{ cancelActionText }}
				</v-btn>
			</v-flex>
			<v-flex text-xs-center v-if="!!successActionText">
				<v-btn
					small
					type="button"
					:disabled="disabled"
					class="btn-action btn-detail btn-disabled-background"
					color="primary"
					slot="activator"
					@click="$emit('success-action')"
				>
					{{ successActionText }}
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import graphicComponent from '@/components/surveys/graphic-component';

function disabled() {
	return this.selectFactors || this.disabledWeighing || this.disabledQuestions;
}

export default {
	name: 'graphic-factors',
	components: {
		graphicComponent,
	},
	computed: {
		disabled,
	},
	props: {
		cancelActionText: String,
		disabledQuestions: {
			default: false,
			type: Boolean,
		},
		disabledWeighing: {
			default: false,
			type: Boolean,
		},
		successActionText: String,
		number: Number,
		rotatedCard: {
			type: Boolean,
			default: false,
		},
		selectFactors: {
			type: Boolean,
			default: false,
		},
		showStep: {
			type: Boolean,
			default: true,
		},
		showNumber: {
			type: Boolean,
			default: true,
		},
		title: String,
		width: {
			type: String,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>

.content-factors {
	background-color: color(white);
	border: solid 1px color(gray-slider);
	border-radius: 9px;
	height: fit-content;
	margin-left: auto;
	padding-top: 24px;
	perspective: 1200px;
	top: 101px;
	transform-style: preserve-3d;
	transition: all 1s ease;

	@media (min-width: 920px) {
		position: fixed;
		width: calc(38.6% - 125px);
	}

	@media (min-width: 991px) {
		width: calc(38.1% - 125px);
	}

	@media (min-width: 1050px) {
		width: calc(37.6% - 125px);
	}

	@media (min-width: 1090px) {
		width: calc(37.1% - 125px);
	}

	@media (min-width: 1140px) {
		width: calc(36.6% - 125px);
	}

	@media (min-width: 1224px) {
		width: calc(36.1% - 125px);
	}

	@media (min-width: 1260px) {
		width: calc(35.6% - 125px);
	}
}

.text-blue {
	border-bottom: 1px solid color(gray-light);
	font-family: map-get($fonts, bold);
	font-size: map-get($sizes, medium);
	margin: 0px 40px;
	padding: 10px 0;
	text-align: center;
	text-transform: uppercase;
}

.left-btn {
	margin-left: 20px;
}

.buttons-factors {
	border-top: 1px solid color(gray-slider);
	height: 61px;
}

.v-avatar {
	height: 34px !important;
	width: 34px !important;
}

.card {
	margin: 0 auto;
	height: calc(100vh - 320px);
	overflow-x: hidden;
	overflow-y: auto;
	perspective: inherit;
}

.rotated {
  	transform: rotateY(-180deg);

	.detail-content, .card-layout, .buttons-factors {
		transform: rotateY(180deg);
	}
}

.btn-detail {
	width: 85% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/surveys/graphic-factors.vue